module.exports = __webpack_public_path__ + "img/co.22da0f07.svg";